import styled from 'styled-components';

import Visibility from '../../assets/images/visibility.svg';
import VisibilityOff from '../../assets/images/visibility_off.svg';

export const Wrapper = styled.div`
  min-height: 100vh;
  padding: 14.9vh 16px 8.6vh;
  box-sizing: border-box;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  background-color: #e8e9ea;
  font-family: 'Poppins';
`;

export const InnerWrapper = styled.div`
  width: 382px;
  display: flex;
  flex-flow: column nowrap;
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const Input = styled.input<{ height?: string }>`
  border-radius: 4px;
  border: 1px solid #c3c5c7;
  height: ${(props) => props.height || '64px'};
  background-color: #fff;
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  font-size: 14px;
  font-weight: 500;
  color: #1c232c;
  transition: border-color 0.2s ease-in-out;

  &:focus {
    border-color: #1c232c;
    outline: none;
  }

  @media (max-width: 680px) {
    font-size: 16px;
  }
`;

export const VisibilityIcon = styled.div<{
  isVisible: boolean;
}>`
  position: absolute;
  right: 16px;
  width: 24px;
  height: 24px;
  bottom: 20px;
  background-color: #b0b3b6;
  mask-image: ${(props) =>
    props.isVisible ? 'url(' + Visibility + ')' : 'url(' + VisibilityOff + ')'};
`;

export const SubmitButton = styled.button<{
  isLoading: boolean;
}>`
  background: linear-gradient(-180deg, rgb(65, 71, 79) 0%, rgb(28, 35, 44) 100%);
  border-radius: 4px;
  height: 64px;
  width: 100%;
  border: none;
  outline: none;
  appearance: none;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.24px;
  display: block;
  padding: 16px;
  cursor: pointer;
  opacity: ${(props) => (props.isLoading ? 0.6 : 1)};
  transition: opacity 0.2s ease-in-out;
`;

export const Text = styled.p`
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.24px;
  line-height: 16px;
  margin: 16px 0 24px;
`;

export const LabelText = styled.p`
  color: #666b71;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.24px;
  margin-bottom: 8px;
`;

export const ErrorMessage = styled.p`
  color: #ff263d;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.24px;
  line-height: 16px;
  margin: 8px 0 32px;
`;
